/**
 * Gestionnaire de paramètres utilisateur
 * Gère la persistance du mode sombre et de la taille de police
 */

const SETTINGS_KEY = 'bibleStudy_userSettings';

const DEFAULT_SETTINGS = {
  theme: 'light', // 'light' ou 'dark'
  fontSize: 'medium', // 'small', 'medium', 'large', 'xlarge'
  bibleVersion: 'BDS', // Version de la Bible par défaut
  notificationsEnabled: false, // Notifications activées
};

/**
 * Charge les paramètres depuis localStorage
 * @returns {Object} Paramètres utilisateur
 */
export const loadSettings = () => {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...DEFAULT_SETTINGS,
        ...parsed
      };
    }
  } catch (error) {
    console.error('Erreur lors du chargement des paramètres:', error);
  }
  return DEFAULT_SETTINGS;
};

/**
 * Sauvegarde les paramètres dans localStorage
 * @param {Object} settings - Paramètres à sauvegarder
 */
export const saveSettings = (settings) => {
  try {
    const toSave = {
      ...DEFAULT_SETTINGS,
      ...settings
    };
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(toSave));
    return true;
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des paramètres:', error);
    return false;
  }
};

/**
 * Réinitialise les paramètres aux valeurs par défaut
 */
export const resetSettings = () => {
  try {
    localStorage.removeItem(SETTINGS_KEY);
    return DEFAULT_SETTINGS;
  } catch (error) {
    console.error('Erreur lors de la réinitialisation des paramètres:', error);
    return DEFAULT_SETTINGS;
  }
};

/**
 * Met à jour un paramètre spécifique
 * @param {string} key - Clé du paramètre
 * @param {any} value - Nouvelle valeur
 */
export const updateSetting = (key, value) => {
  const current = loadSettings();
  current[key] = value;
  saveSettings(current);
  return current;
};
